/**
 * meetingInfo.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

//import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogContent, DialogActions, Snackbar, SnackbarContent, Typography } from "@mui/material";

import { Meeting } from "../models/meeting";

import { authServiceFactory } from "../services/auth.service";
import { conferenceServiceFactory } from "../services/conferencing.service";

interface Props {
  open: boolean,
  centered?: boolean,
  meeting: Meeting,
  onClose(): void
}
export function MeetingInfoComponent(props: Props): React.ReactElement<any, any> {
  const conferenceService = conferenceServiceFactory();
  const authService = authServiceFactory();
  const [copyDescText, setCopyDescText] = React.useState<string>("Copy To Clipboard");

  async function copyDesc() {
    try {
      await navigator.clipboard.writeText(conferenceService.shortDescForMeeting(props.meeting, authService.domain));
      setCopyDescText("Copied!");
    } catch (err) {
      console.error("Error copying to clipboard:", err);
    }
  }

  const content = <>
    <Typography variant="h4">Share Your Meeting Info</Typography>
    <DialogContent>
      <p className="meeting-info-desc">
        <span>{conferenceService.urlForMeeting(props.meeting, authService.domain)}</span><br />
        {props.meeting.sipEnabled && authService.US_PHONES.length > 0 && <>
          <span>Dial: {authService.US_PHONES[0]}</span><br />
          <span>PIN: {conferenceService.displayCode(props.meeting.sipCode || "")}</span>
        </>}
      </p>
    </DialogContent>
    <DialogActions>
      <Button color="primary" disableRipple disableTouchRipple
          onClick={props.onClose}>Close</Button>
      <Button color="primary" variant="contained"
          disableRipple disableTouchRipple
          onClick={copyDesc}>
        {copyDescText}
      </Button>
    </DialogActions>
  </>;

  return <Snackbar className="meeting-info-popup-container"
      open={props.open} onClose={props.onClose}
      anchorOrigin={props.centered ? undefined : {vertical: "top", horizontal: "left"}}>
    <SnackbarContent message={content} />
  </Snackbar>;
}
